import { ObjectUtilities } from '@awayfl/swf-loader';
export var builtinNativeClasses = ObjectUtilities.createMap();
export var nativeClasses = ObjectUtilities.createMap();
export var nativeClassLoaderNames = [];
